import React from 'react'
import { Popup } from 'react-leaflet'
import styled from 'styled-components'
import gql from 'graphql-tag'
import proj4 from 'proj4'
import map from 'lodash.map'
import { FormattedMessage } from 'react-intl'

import GraphqlQuery from '../GraphqlQuery'

const GET_LAYER_RESULT = gql`
  query LayerResult($long: Float!, $lat: Float!, $layer: String!) {
    layerResult(point: { long: $long, lat: $lat }, selectedLayer: $layer) {
      metadata
    }
  }
`;

const PopOverLabel = styled.p`
  margin-bottom: 12px !important;
  margin-top: 0 !important;
  font-size: 14px;
  font-weight: 600;
`

const PopOverList = styled.ul`
  max-width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
`

const PopOverListItem = styled.li`
  display: inline-block;
  width: 48%;
  margin-right: 4%;
  margin-bottom: 8px;
  line-height: 1.2;

  &:nth-child(2n) {
    margin-right: 0;
  }

  span {
    display: block;
    margin-bottom: 2px;
    font-size: 12px;
  }

  b {
    font-size: 12px;
    word-break: break-word;
  }
`

const PopupContainer = ({ coordinates, layerId, layersData, onClose }) => {
  if (!coordinates.lat || !coordinates.lng || !layerId) { return null; }

  const { lat, lng } = coordinates;
  const convertedCoordinates = proj4('EPSG:4326', 'EPSG:3857', [lng, lat]);
  const layerData = layersData.find(l => l.nm_layer === layerId);

  return (
    <GraphqlQuery
      query={ GET_LAYER_RESULT }
      variables={ { long: convertedCoordinates[0], lat: convertedCoordinates[1], layer: layerId } }
    >
      {({ layerResult }) => {
        const data = layerResult ? JSON.parse(layerResult.metadata) : null;

        if (!data) { return null; }

        return (
          <Popup
            className="leafletPopup"
            position={ [coordinates.lat, coordinates.lng] }
            onClose={ onClose }
          >
            <PopOverLabel><FormattedMessage id={ `name.layer.${ layerData.id_layer }` } /></PopOverLabel>
            <PopOverList>
              { map(data, (value, key) => {
                  return (
                    <PopOverListItem>
                      <FormattedMessage id={ key } />
                      <b>{ value }</b>
                    </PopOverListItem>
                  );
              }) }
            </PopOverList>
          </Popup>
        );
      }}
    </GraphqlQuery>
  );
}

export default PopupContainer



// WEBPACK FOOTER //
// ./src/components/molecules/Map/Popup.js